<template>
    <div>
        <h4>Gerenciamento de Usuários</h4>
        <hr />
        <b-button
            variant="secondary"
            class="mb-3"
            :disabled="loadingUsers"
            @click="onCreate"
        >
            <i class="fas fa-plus-circle mr-2" />Criar usuário
        </b-button>
        <users-table
            refs="userTable"
            :loading="loadingUsers"
            :users="users"
            @edit="onEdit"
            @remove="onRemove"
        />
        <users-delete ref="userDelete" :user="user" />
        <users-editor ref="userEditor" :user="user" />
    </div>
</template>

<script>
import { mapState } from "vuex";
import sleep from "@/utils/sleep";
import UsersTable from "./components/UsersTable";
import UsersDelete from "./components/UsersDelete";
import UsersEditor from "./components/UsersEditor";

export default {
    name: "UserManagement",
    components: {
        UsersTable,
        UsersDelete,
        UsersEditor
    },
    data() {
        return {
            user: null,
            loadingUsers: false
        };
    },
    computed: mapState("settings/users", ["users"]),
    async mounted() {
        if (this.users.length === 0) {
            this.loadingUsers = true;
            await sleep(1000);
            await this.$store.dispatch("settings/users/getUsers");
            this.loadingUsers = false;
        }
    },
    methods: {
        async onCreate() {
            this.user = null;
            await this.$nextTick();
            this.$refs.userEditor.show();
        },
        async onEdit(user) {
            this.user = user;
            await this.$nextTick();
            this.$refs.userEditor.show();
        },
        async onRemove(user) {
            this.user = user;
            await this.$nextTick();
            this.$refs.userDelete.show();
        }
    }
};
</script>
